<template>
    <v-dialog v-model="modal" width="700" :persistent="loading">
        <v-card :disabled="loading">
            <v-card-title class="d-flex justify-space-between">
                <span>
                    {{ $t('reservation_report') }}
                </span>
                <v-icon @click="modal = false">mdi-close</v-icon>
            </v-card-title>
            <v-card-text>
                <span class="text-caption text-grey mb-2">
                    Select service(s) to send in Reservation Report e-mail to the corresponding supplier(s)
                </span>
                <div class="d-flex flex-column">
                    <div v-for="service in ownServicesObjects" :key="service.processId" class="d-flex flex-column">
                        <div class="font-weight-medium d-flex align-center">
                            <v-checkbox
                                v-model="service.selected"
                                class="mt-0"
                                hide-details
                                :label="service.serviceName"
                            />
                            <span v-if="service.serviceSentToSupplier" class="text-success ms-2 mt-1 text-caption">
                                {{ $t('sent_to_supplier') }}
                                <template v-if="service.serviceSentToSupplierDateTime">
                                    (
                                    <span>
                                        {{ $filters.dateFormat(service.serviceSentToSupplierDateTime) }}
                                    </span>
                                    <span>
                                        {{ $filters.hoursFromDate(service.serviceSentToSupplierDateTime) }}
                                    </span>
                                    )
                                </template>
                            </span>
                            <span v-else class="text-error ms-2 mt-1 text-caption">
                                {{ $t('not_sent_to_supplier') }}
                            </span>
                        </div>
                        <div class="ms-8 d-flex flex-column">
                            <span>
                                <span>
                                    {{ $filters.dateFormat(service.startDateTime) }}
                                </span>
                                <span v-if="service.endDateTime">
                                    -
                                    {{ $filters.dateFormat(service.endDateTime) }}
                                </span>
                            </span>
                            <span :class="statusColor(getStatus(service.status))" class="text-caption">
                                {{ $t(`bookingStatus.${getStatus(service.status)}`) }}
                            </span>
                            <span style="font-size: 10px; margin-top: -2px">
                                {{ service.supplierCompanyName }}
                            </span>
                        </div>
                    </div>
                </div>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn
                    color="primary"
                    :block="$breakpoint.smAndDown"
                    :loading="loading"
                    :disabled="!servicesSelected.length"
                    @click="send"
                >
                    {{ $t('submit') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Prop, VModel, Vue, Watch} from 'vue-facing-decorator'

    @Component
    export class ReservationReportOrderModal extends Vue {
        @VModel() modal
        @Prop() order

        loading = false
        ownServicesObjects = []

        @Watch('order.services', {deep: true})
        onServicesChange() {
            this.setServices()
        }

        mounted() {
            this.setServices()
        }

        setServices() {
            this.ownServicesObjects = this.order.services
                .filter(s => !!runtimeStore.ownProduct(s?.supplierCode))
                .map(s => ({
                    ...s,
                    selected: true,
                }))
        }

        async send() {
            try {
                this.loading = true

                await this.$api.reservationReportMail.post({
                    orderId: this.order.orderId,
                    processIds: this.servicesSelected.map(s => s.processId),
                })

                await runtimeStore.refreshOrder()
                // eslint-disable-next-line no-empty
            } catch (e) {
            } finally {
                this.loading = false
                this.modal = false
            }
        }

        get servicesSelected() {
            return this.ownServicesObjects.filter(s => !!s.selected)
        }

        statusColor(status) {
            return runtimeStore.orderServiceStatusColor(status)
        }

        getStatus(status) {
            return runtimeStore.orderServiceStatus(status)
        }
    }

    export default ReservationReportOrderModal
</script>
